import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=64d220ac&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=64d220ac&prod&scoped=true&lang=css"
import style1 from "./Chat.vue?vue&type=style&index=1&id=64d220ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d220ac",
  null
  
)

export default component.exports